import { useApolloClient } from "@apollo/client";
import { getDataOrNull, notNull } from "@msys/common";
import { LabeledValue } from "@msys/ui";
import { Box, Link as MuiLink, Stack } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import React from "react";
import { Link } from "react-router-dom";
import { useTemplateTypeInput_SearchTemplateTypesQuery } from "./TemplateTypeInput.generated.js";

interface Props {
  templateTypeId: string | null;
  label?: string;
  leftIcon?: React.ReactNode;
  rightButton?: React.ReactNode;
  required?: boolean;
}

export const TemplateTypeLabeledValue = ({
  templateTypeId,
  label,
  leftIcon,
  rightButton,
  required = false,
}: Props) => {
  const { t } = useTranslate(["TemplateTypes", "Global"]);
  const client = useApolloClient();
  const query = useTemplateTypeInput_SearchTemplateTypesQuery({
    client,
    variables: { templateTypeIds: [templateTypeId].filter(notNull) },
    skip: !templateTypeId,
  });
  const templateType = templateTypeId
    ? (getDataOrNull(query.data?.searchTemplateTypes)?.edges?.[0]?.node ?? null)
    : null;
  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <Stack
        direction="row"
        spacing={1}
        sx={{
          alignItems: "center",
          minWidth: 0,
          flex: 1,
        }}
      >
        <LabeledValue
          label={
            label ??
            t("Template type", { ns: "TemplateTypes" }) + (required ? " *" : "")
          }
        >
          {query.loading ? (
            ""
          ) : templateType ? (
            <MuiLink component={Link} to={`/templates/types/${templateTypeId}`}>
              {templateType?.title ?? ""}
            </MuiLink>
          ) : (
            "–"
          )}
        </LabeledValue>
        {leftIcon}
      </Stack>
      {rightButton ? (
        <Box
          sx={{
            display: "flex",
          }}
        >
          {rightButton}
        </Box>
      ) : null}
    </Stack>
  );
};
